import { render, staticRenderFns } from "./DobUpdate.vue?vue&type=template&id=1c96df91"
import script from "./DobUpdate.vue?vue&type=script&lang=js"
export * from "./DobUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports